export const LOAD_ROLES_REQUEST = "LOAD_ROLES_REQUEST";
export const LOAD_ROLES_SUCCESS = "LOAD_ROLES_SUCCESS";
export const LOAD_ROLES_FAIL = "LOAD_ROLES_FAIL";

export const LOAD_ROLE_DETAIL_REQUEST = "LOAD_ROLE_DETAIL_REQUEST";
export const LOAD_ROLE_DETAIL_SUCCESS = "LOAD_ROLE_DETAIL_SUCCESS";
export const LOAD_ROLE_DETAIL_FAIL = "LOAD_ROLE_DETAIL_FAIL";

export const ADD_ROLE_REQUEST = "ADD_ROLE_REQUEST";
export const ADD_ROLE_SUCCESS = "ADD_ROLE_SUCCESS";
export const ADD_ROLE_RESET = "ADD_ROLE_RESET";
export const ADD_ROLE_FAIL = "ADD_ROLE_FAIL";

export const UPDATE_ROLE_REQUEST = "UPDATE_ROLE_REQUEST";
export const UPDATE_ROLE_SUCCESS = "UPDATE_ROLE_SUCCESS";
export const UPDATE_ROLE_RESET = "UPDATE_ROLE_RESET";
export const UPDATE_ROLE_FAIL = "UPDATE_ROLE_FAIL";

export const DELETE_ROLE_REQUEST = "DELETE_ROLE_REQUEST";
export const DELETE_ROLE_SUCCESS = "DELETE_ROLE_SUCCESS";
export const DELETE_ROLE_FAIL = "DELETE_ROLE_FAIL";

export const SEED_ROLES_REQUEST = "SEED_ROLES_REQUEST";
export const SEED_ROLES_SUCCESS = "SEED_ROLES_SUCCESS";
export const SEED_ROLES_FAIL = "SEED_ROLES_FAIL";

export const CLEAR_ROLE_ERRORS = "CLEAR_ROLE_ERRORS";
